import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Grid, Typography } from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  inputGrid: {
    paddingTop: '15px'
  }
}));

export default props => {
  const { numberOfRows } = props;
  const rowCounter = Array.from(
    new Array(numberOfRows || 1),
    (val, index) => index
  );
  const classes = useStyles();

  return rowCounter.map(n => (
    <Grid item xs={12} className={classes.inputGrid} key={n}>
      <Grid item md={6} xs={12}>
        <Typography display="block" style={{ fontSize: '2.2rem' }}>
          <Skeleton />
        </Typography>
      </Grid>
    </Grid>
  ));
};
